import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useMusic24Capabilities } from '../hooks/useMusic24Capabilities';
import { artistHomeMessages as messages } from './artistHomeMessages';
import { HomePeriodDays, HOME_PERIOD_DAYS, homePeriodDays, homePeriodRange } from './homePeriod';

export interface HomePeriod {
  days: HomePeriodDays;
  /** True on a plan whose history is shorter than 28 days (Free): the header shows the lock chip. */
  isShort: boolean;
  /** "Last 28 days · Sep 6 – Oct 3". */
  label: string;
}

/** The period of every Home number, from the workspace capabilities (owner decision 1). */
export function useHomePeriod(): HomePeriod {
  const intl = useIntl();
  const { historyDaysLimit } = useMusic24Capabilities();
  const days = homePeriodDays(historyDaysLimit);

  // Set once per mount: a range that moved with the clock would change on every render.
  const range = useMemo(() => homePeriodRange(days, new Date()), [days]);

  const label = useMemo(() => {
    const format = (value: Date) => intl.formatDate(value, { month: 'short', day: 'numeric' });
    return intl.formatMessage(messages.period, { days, range: `${format(range.from)} – ${format(range.to)}` });
  }, [days, intl, range]);

  return { days, isShort: days < HOME_PERIOD_DAYS, label };
}
